import {
  Logger as ConsoleLogger,
  DEFAULT_FLUSH_INTERVAL,
  DEFAULT_FLUSH_LIMIT,
  ServerLogger,
} from '@lsy-netline/netline-ui/utils';
import { attempt, isError } from 'lodash-es';

const serverLogger = attempt(JSON.parse, process.env.REACT_APP_SERVER_LOGGER);
const allowConsole = process.env.NODE_ENV === 'development' || window?.forceConsoleLogger;
const logger =
  isError(serverLogger) || !serverLogger
    ? new ConsoleLogger({ allowConsole })
    : new ServerLogger({
        // transport: (messages) => services.sendLog({ messages }),
        flushInterval: process.env.NODE_ENV !== 'test' ? DEFAULT_FLUSH_INTERVAL : null,
        flushLimit: process.env.NODE_ENV !== 'test' ? DEFAULT_FLUSH_LIMIT : null,
      });

export default logger;
